module.exports = __webpack_public_path__ + "img/format-pdf.d30add64.svg";